import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';


import ConfirmForm from './ConfirmForm';
import { createVehiclesConfirmation, setQuoteEstimate } from './actions';
import {populateCustomerActivity} from '../Review/actions';
import { updateTitle } from '../SectionTitle/actions';
import { hideLoading, showLoading } from '../LoadingComponent/actions';

const mapStateToProps = (state) => {
    return {
        state: state,
        quoteStart: state.quoteStart,
        userConfirmation: state.userConfirmation
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createVehiclesConfirmation: (vehicles) => dispatch(createVehiclesConfirmation(vehicles)),
        updateTitle: (titleObject) => dispatch(updateTitle(titleObject)),
        hideLoading: ()=>dispatch(hideLoading()),
        showLoading: ()=>dispatch(showLoading()),
        setQuoteEstimate: (estimate)=>dispatch(setQuoteEstimate(estimate)),
        populateCustomerActivity: (data)=> dispatch(populateCustomerActivity(data))
    }
}


class ConfirmationContainer extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        
        if (this.props.quoteStart.underWriting !== undefined) {
            this.props.hideLoading();
        const {policyHolderName} = this.props.quoteStart;
        
        this.props.updateTitle({  
            title: `
            <h1>Great news <span class="policyHolderName">${policyHolderName}</span>, our search of insurance records brought back a lot 
            of information… and we are happy to offer you a great rate on your auto insurance:</h1>
            <div><span class="estimateMonths">$${this.props.state.userConfirmation.estimate}</span> for 6 months</div>
                      
            `,
            subTitle: `So if you are ready, let's get going… just in case your insurance needs changed… lets quickly confirm a few things starting with…is it really you driving that mouse?`,
            image: '<i class="fa fa-star-o" aria-hidden="true"></i>'
        });
            const { vehicles } = this.props.quoteStart.underWriting.underwriting.body.completeQuote;
            //const vehicles = data.body.completeQuote;
            console.log(vehicles);
            this.props.createVehiclesConfirmation(vehicles);
        }
        else {
            
                this.props.history.push('/');
            
        }
    }

    submit = (values) => {
        ////this.props.showLoading();
        this.validateSelection(values);
    }

    validateSelection(values) {
        console.log(values);
        let validationStatus = [];

        for (let item in values) {
            const validationObj = {};
            if (values[item]) {
                validationObj.key = item;
                const { vehicles } = this.props.quoteStart.underWriting.underwriting.body.completeQuote;
                validationObj.value = this.searchForVehicleByUniqueName(item, vehicles);
                validationStatus.push(validationObj);
            }
        }

        let containsFalseValue = _.find(validationStatus, { value: false });
        console.log(containsFalseValue);

        let passesValidation = containsFalseValue === undefined ? true : false;

        if (passesValidation) {
            if(this.props.state.quoteStart.happyPath === true){
                const { completeQuote } = this.props.quoteStart.underWriting.underwriting.body
                if(!this.props.reviewData){
                    this.props.populateCustomerActivity(completeQuote);
                }
                this.props.history.push('/endquote');
            }
            else{
                this.props.history.push('/review');
            }
        }
        console.log(passesValidation);

    }

    searchForVehicleByUniqueName(name, list) {
        console.log(name);
        let term = '::';
        let firstSeperator = name.indexOf(term);
        let lastSeperator = name.lastIndexOf(term);

        const make = name.substring(0, firstSeperator);
        const model = name.substring((firstSeperator + term.length), lastSeperator);
        let year = name.substring(lastSeperator + term.length);

        const found = _.filter(list, {
            year,
            make,
            model
        });

        return found.length > 0 ? true : false;

    }

    getVehicles() {
        //console.log(data.body.completeQuote.vehicles);
    }

    render() {
        const { vehicleOptionList } = this.props.userConfirmation;
        return (
            <div>
                <h1>Confirm your vehicles</h1>
                <p>Which vehicles have you previously owned?</p>
                <ConfirmForm vehiclesList={vehicleOptionList} onSubmit={this.submit} />
            </div>
        );
    }
}

const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(ConfirmationContainer);

export default withRouter(connectedComponent);


// WEBPACK FOOTER //
// ./src/Confirm/ConfirmContainer.js